module.exports = __webpack_public_path__ + "img/login_logo.0a192bf9.png";